import React from 'react'

const Header = () => {

    
  return (
    <header>
        <div className="top-header">
            <span>FREE SHIPPING</span>
            <img src="images/fire.svg" width="36" height="27" alt="emoji" />
        </div>
        <div className="bottom-header">
            <div className="container-xl">
                <div className="d-flex justify-content-between align-items-center">
                    <nav className="nav-left d-none d-md-block">
                        <ul>
                            <li>
                                <a href="#">Contact Us</a>
                            </li>
                        </ul>
                    </nav>
                    <a href="#" className="logo">
                        <img src="images/logo.svg" width="147" height="65" alt="Diddy" />
                    </a>
                    <nav className="nav-right">
                        <ul>
                            <li>
                                <a href="#">
                                    <img src="images/search-icon.svg" width="47" height="46" alt="search" />
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <img src="images/cart-icon.svg" width="45" height="46" alt="cart" />
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </header>
  )
}

export default Header